import ThemeOptions from './ThemeOptions';

import companyList from './models/company/companyList'
import parameterList from './models/parameter/parameterList'
import labelList from './models/label/labelList'
import projectList from './models/project/projectList'

import boardList from './models/board/boardList'
import boardTaskList from './models/board/boardTaskList'
import boardProjectList from './models/board/boardProjectList'

import taskList from './models/task/taskList'
import taskRlist from './models/taskR/taskRlist'
import taskRTrackerList from './models/taskRTracker/taskRTrackerList'

import chatList from './models/msg/chatList'
import messageList from './models/msg/messageList'

import userList from './models/user/userList'

import widgetData from './models/widgetData'
import widget from './models/widget'
import setting from './models/setting'
import menuData from './models/menuData'
import ticket from './models/ticket'
import size from './models/size'
import data from './models/data'
import billing from './models/billing'

import api from './models/api'

export default {
  ThemeOptions,

  companyList,
  projectList,
  parameterList,
  labelList,

  taskList,
  taskRlist,
  taskRTrackerList,

  boardList,
  boardTaskList,
  boardProjectList,

  chatList,
  messageList,
  widgetData,
  widget,
  setting,
  menuData,
  userList,
  ticket,
  size,
  data,
  billing,
  api
};
